
import { NutritionPlan, SupplementPlan, FitnessPlan, MindfulnessPlan } from "@/types/wellness";

export const nutritionPlan: NutritionPlan = {
  meals: [
    {
      name: "Breakfast",
      time: "7:30 AM",
      description: "Greek yogurt with berries and honey",
      completed: true,
    },
    {
      name: "Morning Snack",
      time: "10:30 AM",
      description: "Apple with almond butter",
      completed: true,
    },
    {
      name: "Lunch",
      time: "1:00 PM",
      description: "Grilled chicken salad with avocado",
      completed: false,
    },
    {
      name: "Afternoon Snack",
      time: "4:00 PM",
      description: "Hummus with vegetable sticks",
      completed: false,
    },
    {
      name: "Dinner",
      time: "7:00 PM",
      description: "Baked salmon with quinoa and roasted vegetables",
      completed: false,
    },
  ],
  progress: 40,
};

export const supplementPlan: SupplementPlan = {
  supplements: [
    {
      name: "Multivitamin",
      dosage: "1 tablet",
      time: "8:00 AM",
      description: "Complete daily nutrition support",
      completed: true,
    },
    {
      name: "Omega-3",
      dosage: "1000mg",
      time: "8:00 AM",
      description: "Heart and brain health support",
      completed: true,
    },
    {
      name: "Vitamin D3",
      dosage: "2000 IU",
      time: "8:00 AM",
      description: "Immune support and bone health",
      completed: true,
    },
    {
      name: "Magnesium",
      dosage: "300mg",
      time: "9:00 PM",
      description: "Sleep support and muscle recovery",
      completed: false,
    },
  ],
  progress: 75,
};

export const fitnessPlan: FitnessPlan = {
  exercises: [
    {
      name: "Morning Stretch",
      duration: "10 mins",
      description: "Full body mobility routine",
      completed: true,
    },
    {
      name: "HIIT Workout",
      duration: "20 mins",
      description: "Interval training for cardio and strength",
      completed: false,
    },
    {
      name: "Evening Walk",
      duration: "30 mins",
      description: "Moderate pace outdoor walk",
      completed: false,
    },
  ],
  progress: 33,
};

export const mindfulnessPlan: MindfulnessPlan = {
  practices: [
    {
      name: "Morning Meditation",
      duration: "10 mins",
      description: "Focused breathing to start the day",
      completed: true,
    },
    {
      name: "Midday Mindful Break",
      duration: "5 mins",
      description: "Body scan and present moment awareness",
      completed: false,
    },
    {
      name: "Evening Reflection",
      duration: "10 mins",
      description: "Gratitude practice and day review",
      completed: false,
    },
  ],
  progress: 33,
};

export const handleToggleCompleted = (category: string, index: number) => {
  console.log(`Toggle ${category} item ${index}`);
  // In a real app, this would update state or call an API
};
